import { Component, OnInit } from '@angular/core';

@Component({
    template: '',
    standalone: false
})

export class BaseComponent implements OnInit
{

    // protected appInsightService: AppInsightService;

    constructor()
    {
        // Manually retrieve the monitoring service from the injector
        // so that constructor has no dependencies that must be passed in from child
        // const injector = ReflectiveInjector.resolveAndCreate([
        // 	AppInsightService
        // ]);

        // this.appInsightService = injector.get(AppInsightService);

        // this.logNavigation();
    }

    notifications: number = 0;

    private logNavigation()
    {
        // this.appInsightService.logPageView();
    }

    protected mcOnInit(

    )
    {
    }

    ngOnInit()
    {
        this.mcOnInit();
    }

    scrollTop: boolean = true;
    ionScrollEvent(ev: any)
    {
        var scrollTop = (ev.detail.scrollTop == 0);
        if (this.scrollTop != scrollTop)
        {
            this.scrollTop = scrollTop;
        }
    }
}
